export default __webpack_public_path__ + "static/media/1599.aa20c025.png";